export const YES = '1';
export const NO = '0';
export const KNOWN_ADDRESS = '1';
export const NOT_KNOWN_ADDRESS = '0';
export const OTHER_TYPE = '22';
export const OTHER = 'OTHER';
export const PC = 'PC';
export const TELEPHONE = 'TELEPHONE';
export const TABLETTE = 'TABLETTE';
export const MONTRE = 'MONTRE';
export const OTHER_DYSFUNCTION = '0';
export const OTHER_PLACE = '0';
export const OTHER_OPTION = '0';
export const PRODUCT_TYPE = 153;
export const LATER = 'LATER';
export const OTHER_ELEMENT = '0';
// Prismic popin text/btn attributes
export const ELEGIBILITY_SUBSCRIPTION_MSG_PRISMIC = 'eligibleText';
export const REQUIRED_TOKEN_MSG_PRISMIC_ATTRIBUTE = 'ssoText';
export const INVALID_SN_MSG_PRISMIC_ATTRIBUTE = 'invalidSNText';

export const ELEGIBILITY_SUBSCRIPTION_CANCEL_BTN_PRISMIC_ATTRIBUTE = 'eligibleCancelButton';
export const REQUIRED_TOKEN_CANCEL_BTN_PRISMIC_ATTRIBUTE = 'ssoCancelButton';
export const INVALID_SN_CANCEL_BTN_PRISMIC_ATTRIBUTE = 'invalidSNCancelButton';
//
export const ELIGIBILITY_EXCEPTION_TYPE = 'EligibilityErrorException';
export const ELIGIBILITY_EXCEPTION_MSG = 'Not eligible to create claim';
export const ACCESS_DENIED_EXCEPTION_TYPE = 'AccessDeniedException';
export const ACCESS_DENIED_EXCEPTION_MSG = 'Accès refusé';
export const RELATIVE_FILE_PATH = {
  LEGAL_NOTICE: '/mentions_legales.pdf',
  PRIVACY_POLICY: '/charte_de_confidentialite.pdf',
  TERMS_OF_SERVICE: '/CGU.pdf',
  PACKAGING_INSTRUCTIONS: "Emballage_de_votre_appareil.pdf",
  DEGEOLOC_INSTRUCTIONS: "Dégéolocalisation de votre appareil.pdf"
};
export const STEP_PREFIX = 'step_';
export const URL = {
  LEGAL_NOTICE: "/legal-notice",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_SERVICE: "/terms-of-service",
  CLAIM: "/claim-declare"
}

export const BENEFIT_TYPE = {
  REPAIR: "3",
  REPLACEMENT: "13",
  DIAGNOSTIC: "13",
}

export const DEVICE_NATURE = {
  NEW_DEVICE: "NEW_DEVICE",
  DEVICE_REFURBISHED_BY_MANUFACTURER: 'DEVICE_REFURBISHED_BY_MANUFACTURER'
}

export const CHARACTERISTICS_TYPE = {
  NATURE: "NATURE",
}

export const LOGISTICS_MODE_SELECTED = {
  PROXIMITY: "PROXIMITY",
  CENTRALIZATION: "CENTRALIZATION"
}

export const FOOTER_ITEM = {
  LEGAL_NOTICE: 1,
  PRIVACY_POLICY: 2,
  TERMS_OF_SERVICE: 3,
}

export enum FMIP {
  DISABLED = "DISABLED", 	// désactivé
  ENABLED = "ENABLED",	// activé
  UNKNOWN = "UNKNOWN", 	// inconnu
  ERROR = "ERROR", 	// erreur
}